
(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npFavoriteButton', function () {
        return {
            restrict: 'E',
            replace: true,
            controller: ['$scope', '$http', 'broadcastService', 'documentService', 'browserService', controller],
            templateUrl: paths.FavoriteButtonView,
            scope: {
                favoriteTargetId: '=',
                addRequestUrl: '=',
                removeRequestUrl: '=',
                targetData: '='
            },
            link: function (scope, element, attr) {
                scope.$watch('targetData.isFavorite', function (isFavorite) {
                    if (isFavorite) {
                        element.children()[0].className = scope.browserType == BrowserType.MOBILE ? cssClass.buttonFavoritedMobile : cssClass.buttonFavorited;
                        scope.requestUrl = scope.removeRequestUrl;
                        scope.requestType = requestType.removeRequest;
                    }
                    else {
                        element.children()[0].className = scope.browserType == BrowserType.MOBILE ? cssClass.buttonFavoriteMobile : cssClass.buttonFavorite;
                        scope.requestUrl = scope.addRequestUrl;
                        scope.requestType = requestType.addRequest;
                    }

                    if (scope.targetData.isFavoriteReadonly) {
                        element.children()[0].className += ' ' + cssClass.disabled;
                        scope.Content = globalResources.ForcedFolderHint;
                        if (scope.targetData.type == E.folderTypes.DepartmentFolder) {
                            scope.Content = globalResources.DepartmentFolderHint;
                        }
                    } else {
                        scope.Content = globalResources.Favorite;
                    }
                }, true);
            }
        };
    });

    function controller($scope, $http, broadcastService, documentService, browserService) {
        $scope.requestUrl = '';
        $scope.requestType = '';
        $scope.translation = globalResources;

        $scope.favoriteButtonClick = favoriteButtonClick;
        $scope.BROWSER_TYPE = BrowserType;
        $scope.browserType = browserService.detectBrowserWindow();

        function favoriteButtonClick() {
            if (!$scope.targetData.isFavoriteReadonly) {
                var requestUrl = $scope.requestUrl + '/' + $scope.favoriteTargetId;

                $http.post(requestUrl)
                    .then(function () {
                        //change icon
                        $scope.targetData.isFavorite = !$scope.targetData.isFavorite;
                        //broadcast new favorite item
						var currentDocument = documentService.getDocuments();
						if (currentDocument && currentDocument.documentInformation) {
							currentDocument.documentInformation.isFavorite = $scope.targetData.isFavorite;
							documentService.setDocuments(currentDocument);
						}
						
                        var target = {
                            data: {
                                id: $scope.targetData.documentId || $scope.targetData.id,
                                name: $scope.targetData.name || $scope.targetData.documentName,
                                type: $scope.targetData.nodeType,
                                isDocument: ($scope.targetData.documentId != undefined)
                            },
                            requestType: $scope.requestType
                        };
						broadcastService(broadcastType.favoriteTarget, target);
						broadcastService(broadcastType.favoriteUpdate, $scope.targetData.isFavorite);
						
                    });
            }
            else {

            }
        };

        $scope.$on(broadcastType.toggleFavoriteTarget, function (e, target) {
            favoriteButtonClick();
        });
    }

})();